import { safetyTips, browseTips } from "@/mocks/homeData";

export default function SafetySection() {
  return (
    <section id="safety" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <p className="font-label text-sm text-primary-600 font-medium">安全提示</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
            只看本页入口，远离仿冒页面
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            网络上常出现与官方入口相似、只差一两个字符的仿冒地址。记住下面几条，能帮你避开绝大多数坑。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.title}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 text-lg">
                <i className={tip.icon} />
              </div>
              <div>
                <h3 className="font-heading font-bold text-base text-foreground-950">{tip.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-lightbulb-flash-line" />
            </span>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
              访问小贴士
            </h3>
          </div>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {browseTips.map((tip) => (
              <div key={tip.title} className="rounded-lg bg-background-100 border border-background-200 p-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-lg">
                  <i className={tip.icon} />
                </div>
                <h4 className="mt-3 font-medium text-sm md:text-base text-foreground-950">{tip.title}</h4>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}